// Default funder/program ordering. Sponsored placements are scaffolded but
// disabled until the `funding.sponsorPriority` flag is flipped on. Today this
// simply preserves verified-first relevance ordering.

export type SortableFunder = {
  sponsor_tier?: "featured" | "premium" | null;
  sponsor_until?: string | null;
  verified?: boolean | null;
};

const SPONSOR_PRIORITY_ENABLED = false; // toggle when sponsorship monetization launches

export function isActiveSponsor(f: SortableFunder): boolean {
  if (!f.sponsor_tier) return false;
  if (!f.sponsor_until) return true;
  return new Date(f.sponsor_until).getTime() > Date.now();
}

export function sortFunders<T extends SortableFunder>(items: T[]): T[] {
  if (!SPONSOR_PRIORITY_ENABLED) return items;
  return [...items].sort((a, b) => Number(isActiveSponsor(b)) - Number(isActiveSponsor(a)));
}